import Link from 'next/link'
import React from 'react'
import LazyLoad from 'react-lazyload'
import styled from 'styled-components'

import ButtonSimple from '../../../components/ButtonSimple'
import Container from '../../../components/Container'
import MiniCard from '../../../components/MiniCard/MiniCard'
import { COLLECTION } from '../../../constants/Routes'
import { MEDIA_QUERY_DESKTOP } from '../../../utils/media-query'

const Component = styled.div`
  margin: 4rem 0;
`

const Category = styled.div`
  margin-bottom: 4rem;

  &:last-child {
    margin-bottom: 0;
  }
`

const Tokens = styled.div`
  margin-top: 2rem;
  display: grid;
  grid-column-gap: 1rem;
  grid-row-gap: 2rem;
  grid-template-columns: repeat(2, 1fr);

  ${MEDIA_QUERY_DESKTOP} {
    grid-template-columns: repeat(6, 1fr);
  }
`

const CategoryTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: rgba(255, 255, 255, .85);
`

const TokenContainer = styled.div`
`

const CategoryReleaseDate = styled.div`
  color: rgba(255, 255, 255, .5);
  font-size: 14px;
`

const Controls = styled.div`
  margin-top: 1rem;
`

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: rgba(255, 255, 255, .5);
  line-height: 1;
  margin-bottom: 1.75rem;
`

const NewHomeCollectionsMini = ({ categories }) => {
  return (
    <Container>
      <Component>
        <Title>
          Collections
        </Title>
        {categories.map((c) => {
          const releaseDate = new Date(c.releaseDate)
          const releaseDateLabel = releaseDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })

          return (
            <Category key={c.id}>
              <LazyLoad once>
                <CategoryTitle>
                  {c.name}
                </CategoryTitle>
                <CategoryReleaseDate>
                  {releaseDateLabel}
                </CategoryReleaseDate>
                <Controls>
                  <Link
                    prefetch={false}
                    href={{
                      pathname: COLLECTION,
                      query: { slug: c.slug }
                    }}
                    passHref
                  >
                    <a>
                      <ButtonSimple
                        variant={ButtonSimple.VARIANT_PRIMARY}
                      >
                        View collection
                      </ButtonSimple>
                    </a>
                  </Link>
                </Controls>
                <Tokens>
                  {c.tokens.map(t => {
                    return (
                      <TokenContainer key={t.id}>
                        <MiniCard
                          tokenMetadata={t}
                        />
                      </TokenContainer>
                    )
                  })}
                </Tokens>
              </LazyLoad>
            </Category>
          )
        })}
      </Component>
    </Container>
  )
}

export default NewHomeCollectionsMini
